export default __webpack_public_path__ + "static/media/ScanThaID.c46ba256.png";